const faqs = [
  {
    q: '长日光阴是什么？',
    a: '长日光阴是一个以慢生活美学为核心的内容平台。我们通过深度文章、影像作品和生活美学内容，帮助都市人找回被快节奏生活吞噬的从容与诗意。内容涵盖慢生活、时光记录、生活美学、岁月感、治愈系生活和慢时光六大主题。',
  },
  {
    q: '长日光阴的内容多久更新一次？',
    a: '我们保持每周更新2-3篇原创文章。慢时光通讯每周发送一封精选邮件，将当周最温暖的内容送到你的邮箱。你也可以关注我们的社交媒体账号，获取每日的治愈瞬间。',
  },
  {
    q: '如何订阅慢时光通讯？',
    a: '你可以在首页底部的订阅区域输入邮箱地址，点击订阅即可。每周我们会发送一封精心编辑的邮件，分享慢生活灵感、精选文章和治愈瞬间。你的邮箱地址仅用于发送通讯，不会被用于其他用途。',
  },
  {
    q: '我可以投稿给长日光阴吗？',
    a: '非常欢迎！我们一直在寻找热爱生活、善于用文字或影像记录慢时光的创作者。你可以通过"联系我们"表单提交你的创作想法或作品链接，我们的编辑团队会在7个工作日内回复。',
  },
  {
    q: '长日光阴有线下活动吗？',
    a: '有的。我们定期在不同城市举办"慢时光工作坊"，内容包括茶道体验、胶片摄影漫步、手作陶艺等。活动信息会通过慢时光通讯提前发布。如果你有场地合作或活动策划的想法，也欢迎联系我们。',
  },
  {
    q: '如何与长日光阴进行商业合作？',
    a: '我们欢迎与理念契合的品牌进行合作。合作形式包括品牌内容共创、线下活动联名、产品推荐等。请通过"联系我们"表单说明合作意向，我们会有专人与你对接。我们对于合作品牌有严格的筛选标准，只与真正符合慢生活理念的品牌携手。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
            常见问题
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-lg border border-background-200/70">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 group-open:rotate-45">
                  <i className="ri-add-line text-foreground-400"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}